import Layer from './Layer';
import { toDate } from '../utils';
import moment from 'moment';

const RISKS = {
    1: '注意',
    2: '警戒',
    3: '危険',
    4: '災害切迫',
}

// キキクル 土砂災害
export default class Landslide extends Layer {
    _latest = process.env.REACT_APP_LANDSLIDE_URL;

    constructor() {
        const id = 'landslide-risk';
        const layers = {
            'landslide-risk': {
                type: 'fill',
                source: id,
                'source-layer': 'risk',
            },
            'landslide-risk-stripe': {
                type: 'fill',
                source: id,
                'source-layer': 'risk',
                filter: ['==', 'level', 4],
                minzoom: 5,
            }
        };

        const paintOptions = {
            'landslide-risk': {
                'fill-opacity': 0.6,
                'fill-outline-color': 'rgba(0, 0, 0, 0.0)',
                'fill-color': [
                    'match',
                    ['get', 'level'],
                    1, '#f2e700',
                    2, '#ff2800',
                    3, '#e62dff',
                    4, '#6c008c',
                    'rgba(0, 0, 0, 0)', // fallback
                ],
            },
            'landslide-risk-stripe': {
                'fill-pattern': 'stripe_black',
            }
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'landslide', layers: ['landslide-risk-stripe', 'landslide-risk'], isShow: true },
        ];

        super(id, layers, paintOptions, elements);
    }

    set latest(latest) { this._latest = latest; }
    get latest() { return this._latest; }

    setDemoUrl(datetime) {
        const YYYYMMDDHHmm = moment(datetime).utc().format("YYYYMMDDHHmm");
        this._latest = `${process.env.REACT_APP_LANDSLIDE_DEMO_URL}/${YYYYMMDDHHmm}/tile.json`;
    };

    onClick(e) {
        const layers = ['landslide-risk'];
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: layers,
        });

        if (!features.length) {
            return;
        }

        const content = features.map(x => {
            return RISKS[x.properties?.level];
        });

        return 'キキクル土砂災害<ul>' + content.map(x => `<li>${x}</li>`).join('') + '</ul>';
    }

    async add() {
        return fetch(this._latest)
            .then(res => res.json())
            .then(json => {
                this.map.addSource(this.id, {
                    type: 'vector',
                    tiles: [json.vt],
                    maxzoom: 8
                });

                Object.keys(this.layers)
                    .map(x => {
                        console.log('addLayer', x);
                        this.map.addLayer({
                            id: x
                            , ...this.layers[x]
                            , paint: { ...this._paintOptions[x] }
                        })
                    });

                this.datetime = toDate(json.ref_time);
                console.log(`loaded Landslide ${this.datetime}`)
            });
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }
};


